'use strict';

const { hydrate } = require('@grpn/hydration');

const CouponsGrid = require('./coupons-grid');

module.exports = hydrate('CouponsGrid', CouponsGrid);
